import axios from "axios";
// import { toastr } from "react-redux-toastr";

import { logout, updateTokens } from "../actions/baseActions";
import { store } from "../store/store";

axios.interceptors.request.use(
  config =>
    // config.timeoutId = setTimeout(() => {
    //   toastr.warning(
    //     "Aguarde mais um pouco",
    //     "Ainda estamos processando sua requisição."
    //   );
    // }, 500);
    config
);

axios.interceptors.response.use(
  response =>
    // clearTimeout(response.config.timeoutId);
    response,
  error => {
    // clearTimeout(error.config.timeoutId);
    if (
      error.response?.data.message === "Token has expired" ||
      error.response?.data.message === "Token Signature could not be verified."
    ) {
      store.dispatch(logout());

      // REFRESH TOKEN:

      //   const currentState = store.getState();
      //   const refreshToken = currentState.user.refresh_token;

      //   axios
      //     .post(`${URL.api}refreshToken`, {
      //       refresh_token: refreshToken
      //     })
      //     .then(resp => {
      //       if (resp.data.success) {
      //         const newRefreshToken = resp.data.refresh_token;
      //         const newToken = resp.data.access_token;

      //         store.dispatch(updateTokens(newToken, newRefreshToken));

      //         originalRequest.headers.Authorization = `Bearer ${newToken}`;
      //         // Reenvia a requisição original com o novo token
      //         return axios(originalRequest);
      //       }
      //       // Se a requisição refresh token falhar, faz logout
      //       store.dispatch(logout());
      //     });
    }
    return Promise.reject(error);
  }
);

export default axios;
